export const numbers = (val, prevVal) => {
    if (!val || val.length === 0) {
        return '';
    }
    return Number.isNaN(parseInt(val, 10)) ? prevVal : parseInt(val, 10).toString();
};

export const decimals = (val) => {
    // Remove all chars except numbers and .
    const value = val.replace(',', '.').replace(/[^0-9.]/g, '');

    // Create an array with sections split by .
    const sections = value.split('.');

    // Remove any leading 0s apart from single 0
    if (sections[0] !== '0' && sections[0] !== '00') {
        sections[0] = sections[0].replace(/^0+/, '');
    } else {
        sections[0] = '0';
    }

    // If numbers exist after first .
    if (sections[1]) {
        // Join first two sections and truncate end section to length 2
        return `${sections[0]}.${sections[1].slice(0, 2)}`;
        // If original value had a decimal place at the end, add it back
    }
    if (value.indexOf('.') !== -1) {
        return `${sections[0]}.`;
        // Otherwise, return only section
    }
    return sections[0];
};
